import { Injectable } from '@angular/core';
import { CaptureService } from '../capture/capture.service';
import { ProductLoaderService } from '../product-loader/product-loader.service';
import { CopyService } from '../copies/copy.service';
import { ParametersService } from '../parameters/parameters.service';
import { OpEnum } from '../../enums/op.enum';
import { AbreCuentasService } from '../abre-cuentas/abre-cuentas.service';
import { BioCatchService } from '../external/biocatch/biocatch.service';
import { ProductsBiocatchEnum, StepBiocatchEnum } from '../../enums/biocatchContext.enum';

@Injectable({
  providedIn: 'root',
})
export class PreValidateService {

  code: string;

  constructor(
    private captureService: CaptureService,
    private productLoaderService: ProductLoaderService,
    private copyService: CopyService,
    private parametersService: ParametersService,
    private abreCuentasService: AbreCuentasService,
    private bioCatchService: BioCatchService,
  ) { }

  switchFunction(func: string): any {
    switch (func) {
      case 'preCreateFinancial':
        return this.preCreateFinancial();
      case 'showLoadingPCO':
        return this.showLoading();
      case 'hideLoading':
        return this.hideLoading();
      case 'preIncomes':
        return this.Incomes();
      case 'prospectAddressesParticular':
        return this.prospectAddresses('PARTICULAR');
      case 'prospectAddressesLaboral':
        return this.prospectAddresses('LABORAL');
      case 'prospectAddressesCardSend':
        return this.prospectAddresses('CARD_SEND');
      case 'prospectAddresses':
        return this.prospectAddresses('DEFAULT');
      case 'getPcoAmount':
        return this.getPcoAmount();
      case 'createContactInfoParticular':
        return this.createContactInfo('PARTICULAR');
      case 'createContactInfoLaboral':
        return this.createContactInfo('LABORAL');
      case 'prospectOccupation':
        return this.prospectOccupation();
      case 'createClient':
        return this.createClient();
      case 'initBioCatch':
        return this.initBioCatch();
      default:
        break;
    }
  }

  async createClient() {
    await this.captureService.createClient();
    return '200';
  }
  showLoading() {
    this.productLoaderService.show(this.copyService.copies.show_load_pco,
      this.parametersService.getSetting(OpEnum.TIMER_WINDOWS_ORANGE)['PCO']);
    return '200';
  }

  async hideLoading() {
    await this.productLoaderService.hide();
    return '200';
  }

  async preCreateFinancial() {
    await this.captureService.createFinancials().then(() => {
      try {
        this.code = '200';
      } catch (error) {
        this.code = '500';
      }
    }, () => {
      this.code = '500';
    });
    return this.code;
  }

  async prospectAddresses(type: string) {
    await this.captureService.prospectAddresses(type);
    return '200';
  }

  async createContactInfo(type: string) {
    await this.captureService.createContactInfo(type).then(() => {
      try {
        this.code = '200';
      } catch (error) {
        this.code = '500';
      }
    }, () => {
      return this.code = '500';
    });
    return this.code;
  }

  async Incomes() {
    await this.captureService.performIncomes().then(async (res: any) => {
      if (res !== '200') {
        this.code = '500';
      }
      this.code = '200';
    }).catch(() => { this.code = '500'; });
    return this.code;
  }

  async prospectOccupation() {
    await this.captureService
      .sendProspectOccupation()
      .then((res: any) => {
        if (res) {
          console.log('aqui');
          this.abreCuentasService.setinfoInferredIncomes(res.body.data);
          console.log('aqui2');
          if (!res.status || res.status === 500) {
            this.code = '500';
          } else if (res.status !== 200) {
            const codigo = res.body.data.codigo;
            switch (codigo) {
              case '422-06':
                this.code = '106';
                break;
              case '422-07':
                this.code = '106';
                break;
              case '400':
                this.code = '500';
                break;
            }
          } else if (res.body.data.income_amount.amount === 0) {
            this.code = '106';
          } else {
            this.code = '000';
          }
        } else {
          this.code = '500';
        }
      })
      .catch(() =>
        this.code = '500',
      );
    return this.code;
  }

  async getPcoAmount() {
    await this.captureService.getPcoAmount().then(data => { this.code = data; });
    return this.code;
  }

  initBioCatch() {
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.bioCatchService.changeContext(StepBiocatchEnum.captura, product);
    return '200';
  }
}
